import type { DrawingTool } from "../canvas/canvasTypes";
import { crayonBrush } from "./CrayonBrush";
import { eraserBrush } from "./EraserBrush";
import { markerBrush } from "./MarkerBrush";
import { pencilBrush } from "./PencilBrush";
import type { BrushDefinition } from "./brushTypes";

export const drawingTools: readonly DrawingTool[] = ["pencil", "marker", "crayon", "eraser"];

const registry: Record<DrawingTool, BrushDefinition> = {
  pencil: pencilBrush,
  marker: markerBrush,
  crayon: crayonBrush,
  eraser: eraserBrush,
};

export function getBrush(tool: DrawingTool): BrushDefinition {
  return registry[tool];
}

export function isDrawingTool(value: string): value is DrawingTool {
  return drawingTools.some((tool) => tool === value);
}
